import { useMemo, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import QueryString from 'query-string'

import authSelectors from 'models/Authentication/selectors'

import { APP_URLS } from 'resources/urls'

import SpinnerScreen from 'screens/SpinnerScreen'

const Root = () => {
  const history = useHistory()
  const location = useLocation()

  const isAuthenticated = useSelector(authSelectors.getIsAuthenticated)

  const redirectFrom = useMemo(() => location?.state?.from || null, [location])

  const isSignInUrl = useMemo(
    () => [APP_URLS.SIGN_IN, APP_URLS.SIGN_IN_VERIFY_CODE].includes(location.pathname),
    [location.pathname],
  )
  const authRedirectRoute = useMemo(() => {
    const { pathname: nextPath, search } = redirectFrom || {}
    if (nextPath) {
      const combinedDeeplinkPath = QueryString.stringifyUrl({
        url: nextPath,
        query: QueryString.parse(search),
      })
      return combinedDeeplinkPath
    }
    return APP_URLS.WALLET
  }, [redirectFrom])

  useEffect(() => {
    if (isAuthenticated) {
      history.replace(authRedirectRoute)
    } else if (redirectFrom) {
      history.replace(APP_URLS.SIGN_IN, { from: redirectFrom })
    } else if (!isSignInUrl) {
      history.replace(APP_URLS.LANDING_PAGE)
    }
  }, [history, isAuthenticated, authRedirectRoute, redirectFrom, isSignInUrl])

  return <SpinnerScreen />
}

export default Root
